import "./Footer.css";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import React from "react";
import Logo from "../../../assets/logo.svg";
import {smoothScrollTo} from "../../../utils/smoothScroll.js";
const Footer = () => {
  const { t } = useTranslation();

  return (
    <footer className="footer">
      <div className="footer__content text_color-white">
            <img className="h-18" src={Logo} alt="Logo" />

         <nav className="hidden lg:flex flex-col text-lg items-center space-y-2">
          <a
              href="#about"
              onClick={(e) => {
                e.preventDefault();
                smoothScrollTo("about");
              }}
              className="hover:text-white transition-colors cursor-pointer"
          >
            {t("header.about")}
          </a>


          <a
              className="hover:text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                setIsServicesOpen(false);
                smoothScrollTo("cultural");
              }}
          >
            {t("services.culture")}
          </a>
          <a
              className="hover:text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                setIsServicesOpen(false);
                smoothScrollTo("outdoor");
              }}
          >
            {t("services.nature")}
          </a>
          <a
              className="hover:text-white transition-colors cursor-pointer"
              onClick={(e) => {
                e.preventDefault();
                setIsServicesOpen(false);
                smoothScrollTo("extreme");
              }}
          >
            {t("services.extreme")}
          </a>
        </nav>


        <div className="footer__social-media">
          <p className="phone footer__phone text-xl">+7 (916) 407-71-44</p>

          <div className="flex space-x-4">
            <Link to="https://t.me/premium_tourism">
              <svg
                className="footer__icon telegram"
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  id="Subtract"
                  fillRule="evenodd"
                  clipRule="evenodd"
                  d="M36 18C36 27.9411 27.9411 36 18 36C8.05888 36 0 27.9411 0 18C0 8.05888 8.05888 0 18 0C27.9411 0 36 8.05888 36 18ZM12.0537 16.3511C10.2505 17.1384 8.39781 17.9473 6.70369 18.8805C5.81908 19.5281 6.99479 19.9864 8.09779 20.4161C8.27315 20.4844 8.44666 20.552 8.60977 20.6196C8.74549 20.6613 8.88352 20.7052 9.02339 20.7498C10.2501 21.1406 11.6181 21.5765 12.809 20.9209C14.7654 19.797 16.6117 18.4977 18.4566 17.1994C19.0611 16.774 19.6654 16.3487 20.2733 15.9298C20.3018 15.9115 20.3339 15.8907 20.3691 15.8679C20.887 15.5322 22.0518 14.7772 21.6209 15.8175C20.6021 16.9317 19.5108 17.9181 18.4136 18.9097C17.6741 19.5781 16.932 20.2488 16.2074 20.9628C15.5764 21.4755 14.9212 22.5066 15.6278 23.2245C17.2552 24.3638 18.908 25.4755 20.5599 26.5865C21.0974 26.948 21.6349 27.3095 22.1714 27.6719C23.0805 28.3978 24.5014 27.8106 24.7013 26.6764C24.7902 26.1546 24.8794 25.6328 24.9686 25.111C25.4618 22.2275 25.9552 19.343 26.391 16.4501C26.4502 15.9963 26.5174 15.5426 26.5846 15.0886C26.7474 13.9882 26.9104 12.8866 26.9613 11.7803C26.8301 10.6764 25.4915 10.9191 24.7466 11.1673C20.9177 12.6243 17.127 14.1892 13.3514 15.7818C12.9237 15.9713 12.4901 16.1606 12.0537 16.3511Z"
                  fill="#D5DEE8"
                />
              </svg>
            </Link>
            <Link to="https://wa.me/79164077144">
              <svg
                className="footer__icon whatsapp"
                width="36"
                height="36"
                viewBox="0 0 36 36"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g id="Vector">
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 18C0 27.9411 8.05887 36 18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18ZM29.2965 17.3111C29.2942 23.2112 24.4945 28.012 18.5932 28.0144H18.5888C16.7975 28.0138 15.0373 27.5643 13.4739 26.7116L7.79993 28.2L9.31839 22.6536C8.38173 21.0304 7.88886 19.1891 7.88966 17.3027C7.89201 11.4013 12.6935 6.59999 18.5931 6.59999C21.4564 6.60123 24.1438 7.71589 26.1646 9.73905C28.1854 11.7621 29.2977 14.4512 29.2965 17.3111Z"
                    fill="#D5DEE8"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M10.3699 25.6572L13.7369 24.7739L14.0618 24.9667C15.4277 25.7773 16.9934 26.2062 18.5897 26.2068H18.5933C23.4966 26.2068 27.4875 22.2159 27.4894 17.3105C27.4903 14.9334 26.5659 12.6983 24.8863 11.0168C23.2066 9.33518 20.973 8.40866 18.5968 8.40784C13.6897 8.40784 9.69885 12.3983 9.6969 17.3033C9.69621 18.9843 10.1665 20.6214 11.0571 22.0377L11.2686 22.3743L10.3699 25.6572ZM23.6195 19.6156C23.806 19.7057 23.9319 19.7666 23.9857 19.8564C24.0526 19.9679 24.0526 20.5033 23.8298 21.1281C23.6069 21.7528 22.5384 22.323 22.0246 22.3998C21.5638 22.4687 20.9808 22.4974 20.3401 22.2938C19.9517 22.1705 19.4535 22.006 18.8155 21.7304C16.3083 20.6478 14.6139 18.2178 14.2937 17.7585C14.2713 17.7264 14.2556 17.7039 14.2468 17.6922L14.2447 17.6893C14.1031 17.5005 13.1548 16.2351 13.1548 14.9256C13.1548 13.6937 13.7599 13.048 14.0385 12.7508C14.0575 12.7304 14.0751 12.7117 14.0908 12.6945C14.3359 12.4268 14.6257 12.3598 14.804 12.3598C14.9823 12.3598 15.1607 12.3615 15.3166 12.3693C15.3358 12.3703 15.3558 12.3701 15.3765 12.37C15.5323 12.3691 15.7266 12.368 15.9183 12.8284C15.992 13.0056 16.0999 13.2683 16.2137 13.5453C16.4439 14.1056 16.6981 14.7246 16.7429 14.8142C16.8097 14.948 16.8543 15.1042 16.7651 15.2827C16.7518 15.3095 16.7394 15.3348 16.7276 15.3589C16.6606 15.4956 16.6114 15.5962 16.4977 15.7288C16.453 15.781 16.4068 15.8373 16.3607 15.8935C16.2687 16.0056 16.1767 16.1176 16.0965 16.1974C15.9627 16.3308 15.8233 16.4754 15.9793 16.7432C16.1353 17.0109 16.672 17.8867 17.4671 18.5959C18.3217 19.3582 19.0645 19.6804 19.441 19.8437C19.5146 19.8756 19.5741 19.9014 19.6178 19.9233C19.8851 20.0572 20.0412 20.0348 20.1972 19.8564C20.3532 19.6779 20.8657 19.0754 21.044 18.8077C21.2222 18.5401 21.4006 18.5846 21.6457 18.6739C21.8909 18.7632 23.2058 19.4101 23.4732 19.544C23.5254 19.5701 23.5742 19.5937 23.6195 19.6156Z"
                    fill="#D5DEE8"
                  />
                </g>
              </svg>
            </Link>
          </div>
        </div>
      </div>

      <div className="createBy">
        {" "}
        <span> Создано в </span>
        <a href="https://snv-studio.ru">SNV-Studio </a>
      </div>
    </footer>
  );
};
export default Footer;
